import React, { Component } from 'react'
import moment from 'moment'
import { DateRangePicker } from 'react-dates'
import { QueryService } from 'services/queries'
import ErrorType from 'services/ErrorType'
import config from 'services/config'
import MoneyValue from 'components/MoneyValue'

import 'react-dates/lib/css/_datepicker.css'

//import jQuery from 'services/jQueryDatatablesBootstrap'
import { BootstrapTable, TableHeaderColumn, ExportCSVButton } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import Spinner from 'react-spinkit'

let _moneyFormat = value => (<MoneyValue value={value}/>)
let _dateFormat = date => moment(date).format('M/D/YYYY')
let _humanize = s => {
  return s ? s.replace(/_/g, ' ').trim().replace(/([^\s])([A-Z])/g, '$1 $2').replace(/\b[A-Z][a-z]+\b/g, function (x) {
    return x.toLowerCase();
  }).replace(/^[a-z]/g, function (x) {
    return x.toUpperCase();
  }) : null;
};
let _humanizeJournal = s => (_humanize(s) || 'Total outstanding')
let _booleanFormat = x => x ? '✓' : ''
let _textFormat = s => s.toString()


class AccountSummaryAge extends Component {

  render() {

    return (
      <div className="card">
        <h3 className="card-title">
          Summary as of {this.props.date.format('MMMM D, YYYY')}
          <div className="pull-right"><MoneyValue value={this.props.data[0].balance}/></div>
        </h3>
          <table className="table table-condensed table-hover">
            <thead>
              <tr>
                <th className="col-md-2 text-left"></th>
                <th className="col-md-1 text-right border-right">Balance</th>
                <th className="col-md-1 text-right">Amount due</th>
                <th className="col-md-1 text-right">0-15 days</th>
                <th className="col-md-1 text-right">16-30 days</th>
                <th className="col-md-1 text-right">31-60 days</th>
                <th className="col-md-1 text-right">61-120 days</th>
                <th className="col-md-1 text-right">120+ days</th>
              </tr>
            </thead>
            <tbody>
              {this.props.data.map(row => (row.balance != 0) && (
                <tr className={ (row.journal === this.props.journal) ? 'warning' :'' }
                    onClick={this.props.onChange}
                    id={row.journal}
                    style={{cursor: 'pointer'}} >
                  <td className="text-left">{_humanize(row.journal_display) || 'Total outstanding'}</td>
                  <td className="text-right border-right"><MoneyValue value={row.balance}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_due}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_0_15}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_16_30}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_31_60}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_61_120}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_120_plus}/></td>
                </tr>
              ))}
            </tbody>
          </table>
      </div>
    )

  }

}


class PaymentDetails extends Component {

  constructor(props) {
    super(props)
    this.onRowClick = this.onRowClick.bind(this)
  }

  onRowClick(row) {
    this.props.history.push({
      pathname: '/dashboard/accounts',
      state: { account: row.contract, date: row.report_date }
    })
  }

  render() {

    return (
      <div className="card">
        <div className="card-body">
          { (this.props.loading) && <Spinner name='circle' /> }
          <BootstrapTable
            data={this.props.data}
            striped
            hover
            pagination
            exportCSV
            csvFileName={`payment_details_${this.props.date.format('YYYY_MM_DD')}.csv`}
            search
            trStyle={ () => ({cursor: 'pointer'})}
            options={{
              sizePerPage: 50,
              paginationShowsTotal: true,
              paginationPosition: 'top',
              hideSizePerPage: true,
              defaultSortName: 'due_date',
              defaultSortOrder: 'asc',
              exportCSVBtn: () => <ExportCSVButton className='btn-blue'/>,
              onRowClick: this.onRowClick
            }}>
            <TableHeaderColumn dataField="due_date" dataFormat={_dateFormat} csvFormat={_dateFormat} dataSort width="7em">Payment date</TableHeaderColumn>
            <TableHeaderColumn dataField="account" csvFormat={_textFormat} dataSort width="10em">Account</TableHeaderColumn>
            <TableHeaderColumn dataField="contract" csvFormat={_textFormat} dataSort width="10em" isKey>Contract</TableHeaderColumn>
            <TableHeaderColumn dataField="provider" dataSort width="10em" >Entity</TableHeaderColumn>
            <TableHeaderColumn dataField="currency" dataSort dataAlign="right" width="6em">Currency</TableHeaderColumn>
            <TableHeaderColumn dataField="payment_amount" dataSort dataFormat={_moneyFormat} dataAlign="right" width="7em">Scheduled</TableHeaderColumn>
            <TableHeaderColumn dataField="paid_amount" dataSort dataFormat={_moneyFormat} dataAlign="right" width="7em">Paid</TableHeaderColumn>
            <TableHeaderColumn dataField="adjustment" dataFormat={_humanize} csvFormat={_humanize} dataSort dataAlign="left" width="7em">Adjustment</TableHeaderColumn>
            <TableHeaderColumn dataField="billable" dataSort width="14em" dataAlign="left">Status</TableHeaderColumn>
            <TableHeaderColumn dataField="pay_method" dataSort dataAlign="left" width="6em">Method</TableHeaderColumn>
          </BootstrapTable>
        </div>
      </div>
    )
  }
}


class Payments extends Component {

  constructor(props) {

    super(props)
    this.state = {
      transactionStartDate: moment(),
      transactionEndDate: moment().endOf('month'),
      focusedInput: null,
      payments: [],
      summary: [],
      journal: null,
      currentPage: 1,
      pageSize: 100,
      recordCount: 0,
      loading: false
    }

    this.onTransactionDatesChange = this.onTransactionDatesChange.bind(this);
    this.isOutsideTransactionDateRange = this.isOutsideTransactionDateRange.bind(this);
    this.onPaginationChanged = this.onPaginationChanged.bind(this)
    this.onJournalChange = this.onJournalChange.bind(this)
    this.fetchPaymentDetails = this.fetchPaymentDetails.bind(this)
    this.fetchAgingSummary = this.fetchAgingSummary.bind(this)
    this._fetchPayments = this._fetchPayments.bind(this)
    this.queryService = new QueryService(this.props.book)

  }

  componentWillMount() {
    this._fetchPayments(this.state.transactionStartDate, this.state.transactionEndDate)
  }

  onTransactionDatesChange({startDate, endDate}) {
    this.setState({
      transactionStartDate: startDate,
      transactionEndDate: endDate
    })
    if (startDate && endDate) {
      this._fetchPayments(startDate, endDate)
    }
  }

  onJournalChange(journalEvent) {
    let journal = journalEvent.currentTarget.id || null 
    this.setState({
      journal: journal
    });
  }

  async fetchAgingSummary(date) {
    try {
      let result = await this.queryService.getAgingSummary(date)
      this.setState({
        summary: result.summary
      })
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }

  //async fetchAgingAccountsFirst(date) {
  //  try {
  //    let result = await queryService.getAgingAccountsFirst(date)
  //    this.setState({
  //      balances: result.balances,
  //      loading: true
  //    })
  //  } catch (err) {
  //    if (err && err.type) {
  //      if (err.type === ErrorType.Authorization) {
  //        this.props.history.push(config.loginPage)
  //        return
  //      }
  //    }
  //    throw err
  //  }
  //}

  async fetchPaymentDetails(startDate, endDate) {
    try {
      let result = await this.queryService.getUpcomingPayments(startDate, endDate)
      for (let r of result.payments)
        (r.adjustments) && (
          r.adjustment = JSON.parse(r.adjustments)
            .filter( a => moment(r.due_date).isBetween(a.start_date, a.end_date, 'day', '[)'))
            .reduce( (m, a) => (moment(a.timestamp).isAfter(m.timestamp) ? a : m), {timestamp: moment(0)}).type
        )
      console.log(result)
      this.setState({...result})
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }

  async _fetchPayments(startDate, endDate) {
    this.setState({loading: true})
//    this.fetchAgingSummary(endDate)
//    await this.fetchAgingAccountsFirst(date)
    this.fetchPaymentDetails(startDate, endDate)
    this.setState({loading: false})
  }


  isOutsideTransactionDateRange(date) {
    return false
  }

  onPaginationChanged(pagination) {

  }

  render() {
    return (
      <div className="content-wrapper">
        <div className="page-title">
          <div>
            <h1><i className="fa fa-credit-card"></i> Payments</h1>
            <p>Payment details</p>
          </div>
          <div className="form-inline">
            {/*<label className="header-input">
              <span className="period">Date</span>
              <SingleDatePicker
                date={this.state.balanceDate}
                onDateChange={this.onBalanceDateChange}
                onFocusChange={this.onBalanceDateFocusChange}
                focused={this.state.balanceDateFocus}
                numberOfMonths={1}
                isOutsideRange={this.isOutsideBalanceDateRange} />
            </label>*/}
            <label className="transaction-date">
                  <span className="period">Period</span>
                  <DateRangePicker
                    startDate={this.state.transactionStartDate}
                    endDate={this.state.transactionEndDate}
                    onDatesChange={this.onTransactionDatesChange}
                    onFocusChange={focusedInput => this.setState({ focusedInput })}
                    focusedInput={this.state.focusedInput}
                    numberOfMonths={3}
                    isOutsideRange={this.isOutsideTransactionDateRange}
                    minimumNights={0}
                  />
            </label>


            {/*<ul className="breadcrumb">
              <li><i className="fa fa-home fa-lg"></i></li>
              <li>Tables</li>
              <li className="active"><a href="#">Simple Tables</a></li>
            </ul>*/}
          </div>
        </div>
          <div className="row small">
          { (this.state.summary.length > 0) &&
            <div className="col-md-12">
              <AccountSummaryAge
                data={this.state.summary}
                date={this.state.balanceDate}
                journal={this.state.journal}
                onChange={this.onJournalChange}
              />
            </div>
          }
          { (this.state.payments.length > 0) &&
            <div className="col-md-12">
              <PaymentDetails
                data={this.state.payments}
                date={moment()}
                journal={this.state.journal}
                loading={this.state.loading}
                history={this.props.history}
              />
            </div>
          }
          </div>
      </div>
    )
  }
}

export default Payments

//                onDateChange={this.onBalanceDateChange}
//                onFocusChange={this.onBalanceDateFocusChange}
//                focused={this.state.balanceDateFocus}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Payments/index.js